import React, { useEffect } from 'react';
import * as apiMethods from '../res/apiMethods.js';
import Sidebar from '../components/Sidebar';
import Button from '@mui/material/Button';

const Debug = () => {
  useEffect(() => {
    const token = window.sessionStorage.getItem('localToken');
    const username = window.sessionStorage.getItem('username');
    if (!token) { window.location.href = '/login'; return; }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!(payload.roleId === 1 && username === 'complemento360')) {
        window.location.href = '/accessDenied';
        return;
      }
    } catch {
      window.location.href = '/accessDenied';
      return;
    }
  }, []);

  const handleCheckMoraUVR = async () => {
    try {
      const token = window.sessionStorage.getItem('localToken');
      const response = await fetch(apiMethods.CHECK_MORA_UVR, {
        headers: { Authorization: token }
      });
      if (!response.ok) throw new Error('Error al descargar');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `check-mora-uvr_${new Date().toISOString().slice(0, 10)}.txt`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error descargando reporte mora UVR:', err);
    }
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '15% 85%' }}>
      <Sidebar />

      <div className="card" style={{ padding: '2rem' }}>
        <div style={{ fontSize: '15pt', fontWeight: '500', marginBottom: '2rem', marginTop: '1rem', marginLeft: '1rem' }}>
          Debug
        </div>

        <div style={{ marginLeft: '1rem' }}>
          <Button
            variant="contained"
            onClick={handleCheckMoraUVR}
            sx={{
              backgroundColor: 'rgb(238,238,238)',
              color: 'black',
              boxShadow: 'none',
              textTransform: 'none',
              '&:hover': { backgroundColor: '#e92128', color: 'white', fontWeight: 'bold', boxShadow: 'none' },
            }}
          >
            Verificar Mora UVR
          </Button>
          <p style={{ marginTop: '0.5rem', fontSize: '12px', color: '#888' }}>
            Descarga un .txt con los créditos UVR que tienen vlrAplicadoIntMora &gt; 0 y vlrAplicadoIntMoraUVR == 0.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Debug;
